import { DateTime } from 'luxon';
import { Instance, types } from 'mobx-state-tree';

import { StudentProduct } from '@common/models/Products/Product';
import ProgramPurchase from '@common/models/Programs/ProgramPurchase';
import ProgramPurchaseProduct from '@common/models/Programs/ProgramPurchaseProduct';

const StudentSimpleProgram = types
	.model('StudentSimpleProgram', {
		program_id: types.identifierNumber,
		group_id: types.maybeNull(types.number),
		program_group_id: types.maybeNull(types.number),
		program_name: types.optional(types.string, ''),
		program_cover: types.maybeNull(types.string),
		total_lessons: types.optional(types.number, 0),
		deadline: types.maybeNull(types.string),
		firstScheduleLessonStart: types.maybeNull(types.string),
		lastScheduleLessonStart: types.maybeNull(types.string),
		is_blocked: types.optional(types.boolean, false),
		is_purchasable: types.optional(types.boolean, false),
		program_products: types.optional(types.array(StudentProduct), []),
		purchase_products: types.optional(types.array(ProgramPurchaseProduct), []),
		purchase: types.maybeNull(ProgramPurchase),
	})
	.views((self) => ({
		get productType(): 'Self-Guided' | 'Mentored' | null {
			if (self.purchase?.is_purchased !== true) return null;

			const name = self.purchase.product?.name.toLowerCase();

			if (name?.includes('self')) return 'Self-Guided';
			if (name?.includes('mentored')) return 'Mentored';

			return null;
		},
		get scheduleDateStart() {
			return DateTime.fromSQL(self.firstScheduleLessonStart);
		},
		get scheduleDateEnd() {
			return DateTime.fromSQL(self.lastScheduleLessonStart);
		},
	}))
	.views((self) => ({
		get scheduleDuration() {
			return `${self.scheduleDateStart.toFormat('yyyy.MM.dd')} - ${self.scheduleDateEnd.toFormat('yyyy.MM.dd')}`;
		},
	}));

export default StudentSimpleProgram;

export interface IStudentSimpleProgramModel extends Instance<typeof StudentSimpleProgram> {}
